import { render } from "./EditFoodOrders-step-3 copy.vue?vue&type=template&id=e6986fde"
import script from "./EditFoodOrders-step-3 copy.vue?vue&type=script&lang=js"
export * from "./EditFoodOrders-step-3 copy.vue?vue&type=script&lang=js"

import "./EditFoodOrders-step-3 copy.vue?vue&type=style&index=0&id=e6986fde&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__